import { CheckCircle2, XCircle } from 'lucide-react'
import { useUserTimezone } from '@/hooks/useUserTimezone'

/** Health icon from execution timestamps — same logic used across
 * TestPlan, TestData, and TestSuites pages. */
export function healthIcon(tc: { lastPassedAt?: Date | string | null; lastFailedAt?: Date | string | null }) {
  const p = tc.lastPassedAt ? new Date(tc.lastPassedAt as any).getTime() : 0
  const f = tc.lastFailedAt ? new Date(tc.lastFailedAt as any).getTime() : 0
  if (!p && !f) return { Icon: CheckCircle2, cls: 'text-muted-foreground' }
  return f > p
    ? { Icon: XCircle, cls: 'text-red-500' }
    : { Icon: CheckCircle2, cls: 'text-green-500' }
}

export function TestCaseListItem({ index, name, isActive, onClick, subtitle, date, lastPassedAt, lastFailedAt }: {
  index: number
  name: string
  isActive: boolean
  onClick: () => void
  subtitle?: string
  date?: Date | string
  lastPassedAt?: Date | string | null
  lastFailedAt?: Date | string | null
}) {
  // #1227: the row date stamp honors the operator's preferred IANA tz.
  // Reading the hook here keeps callers simple — every TestCase list
  // item naturally wants this behavior, and the hook is cheap.
  const tz = useUserTimezone()
  const { Icon: HealthIcon, cls: healthCls } = healthIcon({ lastPassedAt, lastFailedAt })

  return (
    <button
      className={`w-full text-left px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-primary/10 border border-primary/30' : 'hover:bg-muted/50'}`}
      onClick={onClick}
    >
      <div className="flex items-start gap-2">
        <span className="text-xs text-muted-foreground w-5 shrink-0 mt-0.5">{index}.</span>
        <HealthIcon className={`h-4 w-4 mt-0.5 shrink-0 ${healthCls}`} />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium leading-tight">{name}</p>
          <div className="flex items-center gap-1.5 mt-0.5">
            {subtitle && <span className="text-[10px] text-muted-foreground">{subtitle}</span>}
            {date && <span className="text-[10px] text-muted-foreground ml-auto">{new Date(date as any).toLocaleDateString('en-US', { timeZone: tz, month: 'short', day: 'numeric' })}</span>}
          </div>
        </div>
      </div>
    </button>
  )
}
